import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Phone, Mail, HelpCircle } from "lucide-react";

const ContactOptionsDialog = ({ open, onOpenChange, provider, type }) => {
    if (!provider) return null;

    // Determine available options based on contact type
    const options = [];
    if (type === 'phone') {
        if (provider.phone) options.push({ value: provider.phone, label: "Primary Phone" });
        if (provider.phone_2) options.push({ value: provider.phone_2, label: "Secondary Phone" });
    } else if (type === 'email') {
        if (provider.email) options.push({ value: provider.email, label: "Primary Email" });
        if (provider.email_2) options.push({ value: provider.email_2, label: "Secondary Email" });
    }

    const handleContact = (value) => {
        if (type === 'phone') {
            window.open(`tel:${value}`, "_self");
        } else {
            window.open(`mailto:${value}`, "_self");
        }
        onOpenChange(false);
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="rounded-2xl w-[90%] max-w-sm">
                <DialogHeader className="space-y-3 pb-2">
                    <div className="mx-auto bg-primary/10 w-12 h-12 rounded-full flex items-center justify-center mb-2">
                        {type === 'phone' ? (
                            <Phone className="w-6 h-6 text-primary" />
                        ) : (
                            <Mail className="w-6 h-6 text-primary" />
                        )}
                    </div>
                    <DialogTitle className="text-center text-xl font-bold">
                        Contact {provider.name}
                    </DialogTitle>
                    <DialogDescription className="text-center">
                        Select an option to connect
                    </DialogDescription>
                </DialogHeader>

                <div className="space-y-3 pt-2">
                    {options.length > 0 ? (
                        options.map((opt, idx) => (
                            <Button
                                key={idx}
                                onClick={() => handleContact(opt.value)}
                                className="w-full h-auto min-h-[3.5rem] text-left font-medium rounded-xl group py-3 px-4 flex flex-col items-start gap-1"
                                variant="outline"
                            >
                                <span className="text-xs text-muted-foreground group-hover:text-foreground transition-colors uppercase tracking-wide font-semibold">
                                    {opt.label}
                                </span>
                                <span className="font-bold text-foreground group-hover:text-primary transition-colors truncate w-full text-base">
                                    {opt.value}
                                </span>
                            </Button>
                        ))
                    ) : (
                        <div className="flex flex-col items-center justify-center py-6 bg-muted/30 rounded-xl space-y-2 border border-dashed text-center px-4">
                            <HelpCircle className="w-8 h-8 text-muted-foreground opacity-50" />
                            <p className="font-semibold text-foreground">No {type === 'phone' ? 'phone numbers' : 'email addresses'} available</p>
                            <p className="text-xs text-muted-foreground">This provider hasn't listed any contact details for this method.</p>
                        </div>
                    )}
                </div>

                <div className="pt-2">
                    <Button
                        onClick={() => onOpenChange(false)}
                        variant="ghost"
                        size="sm"
                        className="w-full text-muted-foreground h-12 rounded-xl"
                    >
                        Cancel
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default ContactOptionsDialog;
